import Commander from "../Commander";
import * as PIXI from "pixi.js-legacy";
import * as particles from 'pixi-particles';

export default class IdleAnimations {

    constructor(commander) {
        this.commander = commander;

        this.layer = this.commander.layers.idleAnim;

        this.symbols = [];
        this.emitters = [];

        this.idleIntervals = [];
    }

    init() {
        this.initSideParticles();
    }

    initSideParticles() {
        this.emitter = new particles.Emitter(
            this.commander.layers.background,
            PIXI.Texture.from("particle.png"),
            sideParticlesConfig
        );
        this.emitter.updateSpawnPos(0,0);
        this.emitter.emit = true;
        this.emitter.autoUpdate = true;
    }

    stop() {
        for (;this.symbols.length > 0;) {
            createjs.Tween.removeTweens(this.symbols.pop().scale);
        }
        for (;this.emitters.length > 0;) {
            let emitter = this.emitters.pop();
            emitter.cleanup();
            emitter.destroy();
        }
        for (;this.idleIntervals.length > 0;) {
            let interval = this.idleIntervals.pop();
            clearInterval(interval);
        }
        this.layer.removeChildren();
    }

    run() {
        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 3; j++) {
                let symbol = this.commander.slots.getReels()[i].getResSymbols()[j];

                if (symbol.name === "symbol_crystal_seven" || symbol.name === "symbol_crystal_bar") {
                    symbol.scale.set(1,1);
                    createjs.Tween.get(symbol.scale,{loop:true})
                        .to({x: 1.05, y: 1.05},1400,createjs.Ease.sineOut)
                        .to({x: 1, y: 1},1400,createjs.Ease.sineOut);
                    this.symbols.push(symbol);
                    this.createParticles(symbol);
                    this.idleIntervals.push(setInterval(() => this.idleShine(symbol), (3+Math.random()*Math.PI)*1700));
                }
            }
        }
    }

    idleShine(symbol) {
        if (!document[this.commander.hidden]) {
            let shine = Commander.getSprite("symbol_crystal_wild_shine_over.png", symbol.x - symbol.width - 50, symbol.y);
            shine.height = symbol.height;
            shine.width = symbol.width;

            let mask = Commander.getSprite(symbol.name + "_alpha.png", symbol.x, symbol.y);
            mask.mask = shine;
            mask.blendMode = PIXI.BLEND_MODES.ADD;
            shine.blendMode = PIXI.BLEND_MODES.ADD;

            createjs.Tween.get(shine.position)
                .to({x: symbol.x + symbol.width + 50}, 1000)
                .call(() => {
                    Commander.removeTween(shine.position);
                    this.clearShine(mask, shine);
                });

            this.layer.addChild(mask);
            this.layer.addChild(shine);
        }
    }

    clearShine(mask, shine) {
        this.layer.removeChild(mask);
        this.layer.removeChild(shine);
    }

    createParticles(symbol) {
        let texture;
        if (symbol.name === "symbol_crystal_bar")
            texture = PIXI.Texture.from("bar_particle.png");
        else if (symbol.name === "symbol_crystal_seven")
            texture = PIXI.Texture.from("seven_particle.png");


        let emitter = new particles.Emitter(this.commander.layers.background, texture, idleParticlesConfig);
        emitter.updateSpawnPos(symbol.x-75,symbol.y-50);

        emitter.emit = true;
        emitter.autoUpdate = true;

        this.emitters.push(emitter);
    }
}

let idleParticlesConfig = {
    "alpha": {
        "start": 1,
        "end": 0
    },
    "scale": {
        "start": 1.25,
        "end": 0.5,
        "minimumScaleMultiplier": 1
    },
    "color": {
        "start": "#FFFFFF",
        "end": "#FFFFFF"
    },
    "speed": {
        "start": 50,
        "end": 10,
        "minimumSpeedMultiplier": 1
    },
    "acceleration": {
        "x": 6,
        "y": 0
    },
    "maxSpeed": 0,
    "startRotation": {
        "min": 240,
        "max": 300
    },
    "noRotation": false,
    "rotationSpeed": {
        "min": 0,
        "max": 0
    },
    "lifetime": {
        "min": 1,
        "max": 2.5
    },
    "blendMode": "normal",
    "frequency": 0.27,
    "emitterLifetime": -1,
    "maxParticles": 25,
    "pos": {
        "x": 0,
        "y": 0
    },
    "addAtBack": false,
    "spawnType": "rect",
    "spawnRect": {
        "x": 0,
        "y": 0,
        "w": 150,
        "h": 25
    }
};
let sideParticlesConfig = {
    "alpha": {
        "start": 1,
        "end": 0
    },
    "scale": {
        "start": 0.1,
        "end": 0.5,
        "minimumScaleMultiplier": 1
    },
    "color": {
        "start": "#ffffff",
        "end": "#ffffff"
    },
    "speed": {
        "start": 4,
        "end": 1,
        "minimumSpeedMultiplier": 7
    },
    "acceleration": {
        "x": 0,
        "y": 0
    },
    "maxSpeed": 0,
    "startRotation": {
        "min": 0,
        "max": 360
    },
    "noRotation": false,
    "rotationSpeed": {
        "min": 4,
        "max": 5
    },
    "lifetime": {
        "min": 1,
        "max": 5
    },
    "blendMode": "lighten",
    "frequency": 0.05,
    "emitterLifetime": -1,
    "maxParticles": 100,
    "pos": {
        "x": 0,
        "y": 0
    },
    "addAtBack": false,
    "spawnType": "rect",
    "spawnRect": {
        "x": 0,
        "y": 0,
        "w": 1280,
        "h": 720
    }
};